import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 5.6a10.4 10.4 0 1 1 0 20.8 10.4 10.4 0 0 1 0-20.8m0 23.2a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6m-2.2-18.2q-.5-.4-1.2 0-.6.3-.6 1v8.8q0 .6.6 1t1.2 0L21 17a1.2 1.2 0 0 0 0-2zm4.3 5.4-3.7 2.3v-4.6z" })
});
export default SvgPlayCircleRegularIcon;
